
import React, { useEffect, useState } from 'react';
import JobList from '../JobList/JobList';
import styled from 'styled-components';
//import { BaseUrl } from '../UserData';

//const styleApiUrl = `${BaseUrl}/customer/getEmbededCodeSettings?customerName=syra`;

export const fetchStyle = async (url) => {

    try {
        const styledData = await fetch(url);
        const data = await styledData.json();
        const result = data.message[0];
     
        return result ? result : '';
    } catch (err) {
        return '';
    }
};



// export const ColorsAndFonts = {
//     bg_color: fetchStyle('bg_color'),
//     bold_color: fetchStyle('bold_color'),
//     bold_font: fetchStyle('bold_font'),
//     button_color: fetchStyle('button_color'),
//     button_font: fetchStyle('button_font'),
//     button_font_color: fetchStyle('button_font_color'),
//     solids_color: fetchStyle('solids_color'),
//     text_color: fetchStyle('text_color'),
//     text_font: fetchStyle('text_font')
// } 
